import { Box } from '@palmetto/palmetto-components';

import { Diffs } from './Diffs';
import EventBy from './EventBy';

const hiddenProperties = ['meta', '_id', 'id'];

const SabalHoldbackUpdated = ({ event }: { event: any }) => {
  return (
    <Box display="block">
      <EventBy event={event} /> updated a Holdback
      <br />
      <Diffs diff={event?.data?.diff} hiddenProperties={hiddenProperties} />
    </Box>
  );
};

export default SabalHoldbackUpdated;
